import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";

export const JoinUsSubmitApi = createAsyncThunk(
  "JoinUsSlice/JoinUsSubmitApi",
  async (formData, { rejectWithValue }) => {
    try {
      const { data: response } = await axios.post(
        baseUrl + "joinUs/submit",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === "success") {
        return { 
          data: response.data, 
          message: response.message,
          requires_otp_verification: response.requires_otp_verification
        };
      } else {
        return rejectWithValue(response);
      }
    } catch (error) {
      console.error("JoinUs API Error", error);
      
      // Extract meaningful error message from axios error
      if (error.response?.data) {
        // Server returned an error response with data
        const errorData = error.response.data;
        console.log("Server error response:", errorData);
        return rejectWithValue({
          message: errorData.message || 'Server error occurred',
          status: error.response.status,
          nmm_error_type: errorData.nmm_error_type,
          ...errorData
        });
      } else if (error.request) {
        // Network error or no response
        return rejectWithValue({
          message: 'Network error. Please check your connection and try again.',
          status: 0
        });
      } else {
        // Something else happened
        return rejectWithValue({
          message: error.message || 'An unexpected error occurred',
          status: 0
        });
      }
    }
  }
);

export const CompleteNMMRegistrationApi = createAsyncThunk(
  "JoinUsSlice/CompleteNMMRegistrationApi",
  async ({ applicationId, otp }) => {
    try {
      const { data: response } = await axios.post(
        baseUrl + `nmm/complete-registration/${applicationId}`,
        { otp },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.success) {
        return { message: response.message };
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      console.error("NMM OTP API Error", error);
      throw error;
    }
  }
);

export const CompleteApplicationWithNMMApi = createAsyncThunk(
  "JoinUsSlice/CompleteApplicationWithNMMApi",
  async ({ tempApplicationData, otp }, { rejectWithValue }) => {
    try {
      const { data: response } = await axios.post(
        baseUrl + "joinUs/complete-with-nmm",
        { tempApplicationData, otp },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.success) {
        return { 
          data: response.data, 
          message: response.message 
        };
      } else {
        return rejectWithValue(response);
      }
    } catch (error) {
      console.error("Complete Application with NMM API Error", error);
      
      // Extract meaningful error message from axios error
      if (error.response?.data) {
        // Server returned an error response with data
        const errorData = error.response.data;
        console.log("Server error response:", errorData);
        return rejectWithValue({
          message: errorData.message || 'Server error occurred',
          status: error.response.status,
          success: false,
          ...errorData
        });
      } else if (error.request) {
        // Network error or no response
        return rejectWithValue({
          message: 'Network error. Please check your connection and try again.',
          status: 0,
          success: false
        });
      } else {
        // Something else happened
        return rejectWithValue({
          message: error.message || 'An unexpected error occurred',
          status: 0,
          success: false
        });
      }
    }
  }
);
